import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-shared-services';
import { Store } from '@ngrx/store';
import { selectRolesLoaded } from '../store/selectors/pd.selectors';

@Component({
  selector: 'fdr-past-performance-ui-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  protected navbarUrl = environment.brands.enelx.globalNavUrl;
  private translate = inject(TranslateService);
  private cookieService = inject(CookieService);
  private readonly store = inject(Store);
  readonly rolesLoaded = this.store.selectSignal(selectRolesLoaded);

  ngOnInit(): void {
    const { defaults } = environment;
    const locale = this.cookieService.getI18NLocale() || defaults.locale;
    const brand = this.cookieService.getI18NBrand() || defaults.brand.toUpperCase();
    this.translate.setFallbackLang(`${defaults.locale}.${defaults.brand.toUpperCase()}`);
    this.translate.use(`${locale}.${brand}`);
  }
}
